import styled from 'styled-components';

export const MetadataInput = styled.textarea`
  width: 410px;
  min-height: 200px;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-family: monospace;
  font-size: 14px;
  resize: vertical;
`;

export const RunButton = styled.button`
  background: #4CAF50;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 10px 24px;
  font-size: 14px;
  cursor: pointer;
  font-weight: 600;

  &:hover {
    background: #45a049;
  }
`;